import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { ReplacementDataMediumsActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.ReplacementDataMedium };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    ReplacementDataMediumsActions.CreateReplacementDataMedium,
    ReplacementDataMediumsActions.ReadReplacementDataMedium,
    ReplacementDataMediumsActions.UpdateReplacementDataMedium,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    ReplacementDataMediumsActions.CreateReplacementDataMediumSuccess,
    ReplacementDataMediumsActions.ReadReplacementDataMediumSuccess,
    ReplacementDataMediumsActions.UpdateReplacementDataMediumSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    ReplacementDataMediumsActions.CreateReplacementDataMediumFail,
    ReplacementDataMediumsActions.ReadReplacementDataMediumFail,
    ReplacementDataMediumsActions.UpdateReplacementDataMediumFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false,
        loaded: false
      };
    }
  ),
  on(
    ReplacementDataMediumsActions.DeleteReplacementDataMediumSuccess,
    (state, { iri }) => {
      const { [iri]: removedItem, ...entities }: any = state.entities;

      return {
        ...state,
        entities,
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
